/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireHads {
  position: number;
  question: string;
  answers: string[];
}

export const Q_HADS: QuestionnaireHads[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Mi sento agitato e teso:' ,
    answers: [
      'Quasi sempre',
      'Spesso',
      'Qualche volta',
      'Mai'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 2, question: 'Le cose che un tempo mi piacevano, ora mi piacciono:',
    answers: [
      'Nello stesso modo',
      'Meno di prima',
      'Molto poco',
      'Quasi per niente'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 3, question: 'Provo un sentimento di apprensione, come se dovesse succedere qualcosa di terribile:',
    answers: [
      'Sicuramente e in modo intenso',
      'Si, ma in modo non troppo intenso',
      'Un po\', ma non da preoccuparmene',
      'Per niente'
    ]
  },
  {
    // tslint:disable-next-line:max-line-length
    position: 4, question: 'Riesco a ridere e vedere il lato divertente delle cose:',
    answers: [
      'Come ho sempre fatto',
      'Un po\' meno di un tempo',
      'Molto meno di un tempo',
      'Non vi riesco affatto'
    ]
  },
  {
    position: 5, question: 'Mi passano per la mente pensieri preoccupanti',
    answers: [
      'Molto spesso',
      'Spesso',
      'A volte, non troppo spesso',
      'Solo ogni tanto'
    ]
  },
  {
    position: 6, question: 'Mi sento di buon umore:',
    answers: [
      'Mai',
      'Raramente',
      'Qualche volta',
      'Quasi sempre'
    ]
  },
  {
    position: 7, question: 'Riesco a sedermi e rilassarmi:',
    answers: [
      'Sempre',
      'Spesso',
      'Qualche volta',
      'Mai'
    ]
  },
  {
    position: 8, question: 'Mi sento rallentato:',
    answers: [
      'Quasi sempre',
      'Molto spesso',
      'Qualche volta',
      'Mai'
    ]
  },
  {
    position: 9, question: 'Provo un sentimento simile alla paura, come con un senso di tensione allo stomaco:',
    answers: [
      'Mai',
      'Qualche volta',
      'Abbastanza spesso',
      'Molto spesso'
    ]
  },
  {
    position: 10, question: 'Non curo più il mio aspetto fisico:',
    answers: [
      'Completamente',
      'Non me ne curo abbastanza',
      'Forse me ne curo di meno',
      'Me ne curo come al solito'
    ]
  },
  {
    position: 11, question: 'Mi sento irrequieto e incapace di stare fermo:',
    answers: [
      'Moltissimo',
      'Abbastanza',
      'Poco',
      'Per niente'
    ]
  },
  {
    position: 12, question: 'Pregusto con piacere le cose:',
    answers: [
      'Come ho sempre fatto',
      'Un po\' meno di un tempo',
      'Molto meno di un tempo',
      'Quasi per niente'
    ]
  },
  {
    position: 13, question: 'Provo delle sensazioni improvvise di panico:',
    answers: [
      'Molto spesso',
      'Abbastanza spesso',
      'Non molto spesso',
      'Mai'
    ]
  },
  {
    position: 14, question: 'Provo piacere leggendo un libro, oppure seguendo una trasmissione alla radio o alla TV:',
    answers: [
      'Spesso',
      'Qualche volta',
      'Non spesso',
      'Molto raramente'
    ]
  },
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class HADSResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }

}
